import { RecordColorEnum } from '../../../shared/enums/record-color.enum';
import { CustomerStatusEnum } from '../enums/customer-status.enum';

/**
 * Maps the status value to a color value which is used to style the record pill in the UI
 */
export function customerStatusToColor(status: CustomerStatusEnum): string {
	switch (status) {
		case CustomerStatusEnum.ACTIVE:
			return RecordColorEnum.GREEN;

		case CustomerStatusEnum.ON_HOLD:
			return RecordColorEnum.RED;

		case CustomerStatusEnum.CLOSED:
			return RecordColorEnum.SLATE;

		default:
			return RecordColorEnum.DEFAULT;
	}
}
